import {IStore} from "modules/types/store";

export const getGlobalState = ({global}: IStore) => global;

export const getGlobalPreloaderState = ({global}: IStore) => global.isShowGlobalPreloader;

export const getEntryLoadingState = ({global}: IStore) => global.loadingState;
